import { useEffect } from 'react';
import { Route, Switch } from 'react-router';
import { useLocation } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import PrivateRoutes from 'router/PrivateRoutes';
import PublicRoutes from 'router/PublicRoutes';
import Landing from 'screens/Landing';
import { trackPageView } from 'utils/analytics';

export const history = createBrowserHistory();

// Client-side navigation produces no page view of its own, so every route change has to
// report itself. The previous version called the Universal Analytics `window.ga` API,
// which gtag.js never defines — the guard bailed out on every navigation, so nothing
// after the first load was ever recorded.
history.listen((location) => {
  trackPageView(location.pathname + location.search);
});

const Router = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  return (
    <Route
      render={() => (
        <Switch>
          {/* Public marketing page. It has to come before PrivateRoutes, which
              claims "/" and bounces anonymous visitors straight to sign-in. */}
          <Route path="/" component={Landing} exact />
          <Route path="/clients" component={PublicRoutes} />
          <Route path="/" component={PrivateRoutes} />
        </Switch>
      )}
    />
  );
};

export default Router;
